export enum EmployeeType {
    retailer = 1,
    brand = 2,
    brandAdmin = 3,
    superAdmin = 4
}
